import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "ApiLogs", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "id"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Status Code"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "connectionId"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "IP"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "method"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "url"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "action")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex gap-5" }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { class: "text-info" }
const _hoisted_14 = { class: "text-danger" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import TableFooter from "@/components/TableFooter.vue";
import { onMounted, ref } from "vue";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import { Search } from "@element-plus/icons-vue";
import TimeShow from "@/components/TimeShow.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserApiLog',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;



const detailVisible = ref(false);

const isLoading = ref(true);
const dialogItem = ref({});
const items = ref(Array<any>());
const criteria = ref({
  page: 1,
  size: 20,
  partyId: props.partyId,
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;

  try {
    const res = await TenantGlobalService.queryApiLogs(criteria.value);
    items.value = res.data;
    criteria.value = res.criteria;
    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_el_input, {
          modelValue: criteria.value.action,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.action) = $event)),
          style: {"max-width":"600px"},
          clearable: "",
          placeholder: "Search Action",
          class: "input-with-select"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && items.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.statusCode), 1),
                    _createElementVNode("td", null, _toDisplayString(item.connectionId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.ip), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method), 1),
                    _createElementVNode("td", null, _toDisplayString(item.action), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        type: "exactTime",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        type: "exactTime",
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: 
                  () => {
                    dialogItem.value = item;
                    detailVisible.value = true;
                  }
                
                      }, " Details ", 8, _hoisted_10)
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"]),
      _createVNode(_component_el_dialog, {
        modelValue: detailVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
        title: "Detail",
        width: "1000"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.id), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.statusCode), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.connectionId), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.method), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.action), 1)
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_12, "Param: " + _toDisplayString(dialogItem.value.parameters), 1),
          _createElementVNode("div", _hoisted_13, "Request: " + _toDisplayString(dialogItem.value.requestContent), 1),
          _createElementVNode("div", _hoisted_14, " Response: " + _toDisplayString(dialogItem.value.responseContent), 1),
          _hoisted_15
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})